// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0ef1baa4","455":"a70609ce","977":"e0f032b5"}[chunkId] + ".chunk.js";
};